<template>
    <div class="container">
        <van-tabs v-model="active" @change="change" sticky lazy-render>
            <van-tab name="0" title="待支付"></van-tab>
            <van-tab name="1" title="已支付"></van-tab>
            <van-tab name="" title="全部处方"></van-tab>
        </van-tabs>

        <div class="list">
            <div class="item" v-for="(item, index) in list" :key="index">
                <van-tag mark size="large" class="date">
                    {{ item.effectiveTime }}
                </van-tag>
                <div class="header">
                    <span class="title">处方编号：{{ item.id }}</span>
                </div>
                <van-divider />
                <div class="line">
                    <van-row class="row">
                        <van-col span="12" class="title">
                            患者姓名：{{ item.patientName }}
                        </van-col>
                        <van-col span="12" class="title">
                            性别：{{ item.gender }} {{ item.age }}
                        </van-col>
                    </van-row>
                    <van-row class="row">
                        <van-col span="12" class="title">
                            开单科室：{{ item.createDepartmentName }}
                        </van-col>
                        <van-col span="12" class="title">
                            开单医生：{{ item.createUserName }}
                        </van-col>
                    </van-row>
                    <van-row class="row">
                        <van-col span="12" class="title">
                            生效时间：{{ item.effectiveTime }}
                        </van-col>
                        <van-col span="12" class="title">
                            失效时间：{{ item.failureTime }}
                        </van-col>
                    </van-row>
                    <van-row class="row">
                        <van-col span="12" class="title">
                            初步诊断： {{ item.diagnosis }}
                        </van-col>
                        <van-col span="12" class="title">
                            总金额： {{ item.totalFee }}
                        </van-col>
                    </van-row>
                    <van-row class="row">
                        <van-col span="12" class="title">
                            支付状态：
                            {{
                                payStatus.filter(
                                    (it) => it.code === item.payStatus
                                )[0].name
                            }}
                        </van-col>
                        <van-col span="12" class="title">
                            退费状态：
                            {{
                                refundStatus.filter(
                                    (it) => it.code === item.refundStatus
                                )[0].name
                            }}
                        </van-col>
                    </van-row>
                </div>
                <van-divider />
                <div class="footer">
                    <span
                        class="more"
                        v-if="item.payStatus === 1 && item.refundStatus === 0"
                        @click="refundFee(item)"
                        >退费</span
                    >

                    <span class="more" @click="toDetails(item)">处方详情</span>

                    <span
                        class="more"
                        type="default"
                        v-if="item.payStatus === 0"
                        @click="drugPay(item)"
                        >支付</span
                    >
                    <span
                        class="more"
                        v-if="item.payStatus === 1"
                        @click="drugDelivery(item)"
                        >药品配送</span
                    >
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import manageApi from "@/api/manageApi";
import paymentApi from "@/api/paymentApi";

export default {
    data() {
        return {
            active: "",
            list: [],
            listOld: [],
            payStatus: [
                { code: -1, name: "待审核" },
                { code: 0, name: "待支付" },
                { code: 1, name: "已支付" }
            ],
            refundStatus: [
                { code: 0, name: "未退费" },
                { code: 1, name: "已退费" }
            ]
        };
    },
    created() {
        this.init();
    },
    methods: {
        change(n, t) {
            let listOld = JSON.parse(this.listOld);
            if(n) { 
                let result = listOld.filter((item) =>  {
                    return item.payStatus == n;
                })
                this.list = result;
            } else {
                this.list = listOld;
            }
        },
        init() {
            this.list = [];
            if (this.idCard) {
                manageApi.queryByPrescription(this.idCard).then((res) => {
                    this.list = res.data;
                    // 复制数据用于搜索
                    this.listOld = JSON.stringify(this.list);
                });
            } else {
                manageApi.queryPrescription().then((res) => {
                    this.list = res.data;
                    // 复制数据用于搜索
                    this.listOld = JSON.stringify(this.list);
                });
            }
        },
        toDetails(item) {
            const { $router } = this;
            $router.push({
                path: "/manage/prescription_details",
                query: {
                    prescriptionId: item.id
                }
            });
        },
        drugPay(item) {
            const { $router, $dialog } = this;
            paymentApi
                .createMedicalDrugOder({
                    prescriptionId: item.id
                })
                .then((res) => {
                    const data = res.data;
                    $router.push({
                        path: "/payment/payment_order",
                        query: {
                            transactionRecordId: data
                        }
                    });
                })
                .catch((res) => {
                    if (40001 === res.code) {
                        $dialog.confirm({
                            message:
                                "您还有一笔未支付的订单，是否立即前往支付？",
                            beforeClose: (action, done) => {
                                if (action === "confirm") {
                                    const data = res.data;
                                    $router.push({
                                        path: "/payment/payment_order",
                                        query: {
                                            transactionRecordId: data
                                        }
                                    });
                                    done();
                                } else {
                                    done();
                                }
                            }
                        });
                    }
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        drugDelivery(item) {
            const { $router, $dialog } = this;
            $router.push({
                path: "/manage/delivery",
                query: {
                    prescriptionId: item.id
                }
            });
        },
        refundFee(item) {
            const { $dialog, $toast, init } = this;
            $dialog.confirm({
                message: '确认发起退款？到账时间已实际为准.',
                beforeClose: (action, done) => {
                    if (action === 'confirm') {
                        paymentApi.refundMedicalOrder({
                            transactionBillId: item.payId
                        }).then(res => {
                            init();
                            $toast('退款成功');
                            done();
                        });
                    } else {
                        done();
                    }
                }
            });
        }
    },
    props: {
        idCard: {
            type: String,
            required: false
        }
    }
};
</script>

<style lang="less" scoped>
.container {
    .list {
        /deep/.van-divider {
            margin: 0.266667rem 0;
        }
        .item {
            margin: 0.266667rem;
            border-radius: 0.2rem;
            background-color: @white-color;
            padding: 0.266667rem;
            box-shadow: 0.08rem 0.08rem 0.106667rem rgba(26, 26, 26, 0.2);
            font-size: 0.32rem;

            .date {
                background-image: linear-gradient(
                    45deg,
                    @deputy-color,
                    @primary-color
                );
                margin-left: -0.533333rem;
            }

            .header {
                margin-top: 0.266667rem;
                padding: 0 0.266667rem;
                color: @grey-color;

                .title {
                    color: @black-color;
                }
            }

            .line {
                position: relative;
                .row {
                    position: relative;
                    padding: 0.133333rem 0.266667rem;
                    line-height: 0.4rem;
                    color: @grey-color;

                    .title {
                        color: @black-color;
                    }
                }
            }

            .footer {
                text-align: right;
                color: @primary-color;
                .more {
                    margin-left: 20px;
                }
            }
        }
    }
}
</style>
